import { Column } from 'react-virtualized';
import React from 'react';

import ArchTableCell from '../../molecules/ArchTableCell';
import ArchTableHeaderCell from '../../molecules/ArchTableHeaderCell';

// A table with chosen column widths has nothing that can absorb the space left
// over when those widths do not reach the edge. This can: it is the only column
// that grows, and it holds nothing but the header background.
const headerRenderer = props => (
  <ArchTableHeaderCell {...props} disableSort>
    <span />
  </ArchTableHeaderCell>
);

// An empty cell rather than nothing at all: a row's rule is the bottom border of
// its cells, so without one the line stops where the last real column does.
const cellRenderer = () => <ArchTableCell />;

export default class ArchTableSpacerColumn extends Column {
  static defaultProps = {
    ...Column.defaultProps,
    ...{
      cellDataGetter: () => null,
      cellRenderer,
      headerRenderer,
      dataKey: '__spacer',
      // As for every other column: shrink to the width given, like the body does.
      headerStyle: { overflow: 'hidden' },
      disableSort: true,
      width: 0,
      flexGrow: 1,
      flexShrink: 1,
    },
  };
}
